import { useAiScheduleAccess } from '@frontend/ai-receptionist-settings';
import { BookableServiceSelector } from '../../../components/service-selector/bookable-service-selector';
import { ServiceSelector } from '../../../components/service-selector/service-selector';

type AvailabilityServiceSelectorProps = {
  locationId: string;
  orgId: string;
  selectedId?: string;
  onSelect: (appointmentTypeId: string) => void;
};

export const AvailabilityServiceSelector = ({
  locationId,
  orgId,
  selectedId,
  onSelect,
}: AvailabilityServiceSelectorProps) => {
  const { canViewBridgelineScheduleSettings } = useAiScheduleAccess();

  if (canViewBridgelineScheduleSettings) {
    return (
      <ServiceSelector
        locationId={locationId}
        orgId={orgId}
        selectedId={selectedId}
        placement='bottom-start'
        onSelect={onSelect}
      />
    );
  }

  return (
    <BookableServiceSelector
      locationId={locationId}
      selectedId={selectedId}
      placement='bottom-start'
      onSelect={onSelect}
    />
  );
};
